import { useCallback } from "react"
import { EventBus } from "../../eventbus"

export const useChangeProperty = (path: string): ((propertyname: string) => (value: any) => void)[] => {
    const changeProperty = useCallback<(propertyname: string) => (value: any) => void>(
        (propertyname) => (value) => {
            EventBus.instance.emit("changeProperty", `${path}.${propertyname}`, value)
        },
        [path],
    )
    return [changeProperty]
}
